import UserList from './List';
import UserForm from './Form';

export default {
    path: 'cadastros',
    redirect: '/cadastros/usuarios',
    name: 'Cadastro Usuários',
    component: {
        render (c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'usuarios',
            name: 'list-user',
            component: UserList,
            meta: {
                requiresAuth: true,
                label: 'Listar Usuários'
            }
        },
        {
            path: 'usuarios/novo',
            name: 'new-user',
            component: UserForm,
            meta: {
                requiresAuth: true,
                label: 'Novo Usuário'
            }
        },
        {
            path: 'usuarios/:id',
            name: 'edit-user',
            component: UserForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Usuário'
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/views/user/router.js